import type { RouteRecordRaw } from "vue-router";
import FilesPage from "@/views/FilesPage.vue";

// Global page listing files uploaded via the agent shell endpoint.
export const files_routes: RouteRecordRaw = {
  path: "/files",
  component: FilesPage,
  name: "FilesPage",
};
